import React from 'react';

const IncreaseVisibility = () => {
  return (
    <div>
      <h1>Increase Your Visibility.... COMMING SOON....</h1>
      {/* <p>Welcome to the Increase Your Visibility page. Here, you'll find strategies and tips to boost your presence at our event.</p> */}
      {/* Add more content as needed */}
    </div>
  );
};

export default IncreaseVisibility;
